import { DeviceType } from "./device.ts";
import { TaskId } from "./task.ts";

export type DeviceOnboardingType = DeviceType.Computer | DeviceType.Mobile;

/**
 * Whether the Controla App is installed for the OS of the authenticated
 * session's device. Clients decide which platforms are asked to install it.
 */
export interface SessionAgentStatus {
  deviceInventoryId: string;
  agentInstalled: boolean;
}

export function deviceOnboardingType(
  taskId: TaskId,
): DeviceOnboardingType | null {
  if (taskId === TaskId.ADD_COMPUTER) return DeviceType.Computer;
  if (taskId === TaskId.ADD_PHONE) return DeviceType.Mobile;
  return null;
}

/** The "Add your computer" and "Add your phone" tasks. */
export function isDeviceOnboardingTask(taskId: TaskId): boolean {
  return deviceOnboardingType(taskId) !== null;
}
